import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export const RegistrationPopup = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Bestätigung oder Anmeldung{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Sie haben Ihre Registrierungsanfrage erfolgreich übermittelt. Nachdem
          der Administrator Ihre Registrierung genehmigt hat, können Sie sich
          anmelden.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};
